import React from "react";
import "./style.css";

export default function InvoiceHeader() {
	return (
		<header className="invoice-header">
			<div className="invoice-header__icon" aria-hidden="true">
				{/* FileText icon (inline SVG, no lucide dependency) */}
				<svg viewBox="0 0 24 24" width="32" height="32" className="invoice-header__svg">
					<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Zm0 2.5L19.5 10H14V4.5ZM8 13h8a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2Zm0 4h8a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2Zm0-8h4a1 1 0 1 1 0 2H8a1 1 0 0 1 0-2Z" />
				</svg>
			</div>

			<h1 className="invoice-header__title">Moonface Techs Invoice</h1>
			<p className="invoice-header__subtitle">Create professional invoices in minutes</p>
		</header>
	);
}
